'use client';

export { default } from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ../@mui/styled-engine/GlobalStyles/index.js
// module id = 1701
// module chunks = 25